module.exports = __webpack_public_path__ + "img/Dolphin.e78de009.png";